<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex align-center">
        <h4 class="kbDarkBlueText--text">
          {{ $t('general.attachedFiles') }}
        </h4>

        <v-tooltip bottom v-if="campaignStatus === 'draft' || campaignStatus === 'inReview'">
          <template v-slot:activator="{ on }">
            <v-btn
              class="ml-3"
              color="kbPurple"
              dark
              fab
              depressed
              :loading="loadingAttach"
              x-small
              v-on="on"
              @click="openPickFileDialog()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.attachFiles') }}</span>
        </v-tooltip>

        <input
          class="d-none"
          type="file"
          :multiple="true"
          ref="importerInput"
          @change="pickFiles"
        >
      </div>
    </v-col>

    <v-col
      cols="12"
      md="3"
      v-for="(file, index) in campaignFiles"
      :key="`${index}-${file.name}`"
    >
      <v-list color="kbLight">
        <v-list-item class="mb-2">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">
              mdi-attachment
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text font-weight-medium">
              {{ file.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ file.size / (10 ** 6) }} mb
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <div class="d-flex align-center">
              <v-btn
                class="mr-1"
                color="kbBlue"
                icon
                :loading="loadingDownload && selectedFileName === file.name"
                @click="downloadFile(file.name, file.folder)">
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <v-btn
                color="kbRed"
                icon
                :loading="loadingDelete && selectedFileName === file.name"
                @click="deleteAttachment(file.name)"
                v-if="campaignStatus === 'draft' || campaignStatus === 'inReview'"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import campaignsService from '@/services/campaignsService'
import { mapGetters } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapGetters(['token', 'companyUuid', 'appUuid'])
  },
  data () {
    return {
      loadingAttach: false,
      loadingDelete: false,
      loadingDownload: false,
      selectedFileName: ''
    }
  },
  methods: {
    async attachFilesToCampaign (filesToAttach) {
      try {
        const arrayOfPromises = filesToAttach.map(file => {
          campaignsService.uploadFileToCampaign(
            this.token, this.companyUuid, this.appUuid, this.campaignId, file
          )
        })
        await Promise.all(arrayOfPromises)
      } catch (e) {
        notifications.error(e.message)
      }
    },
    async deleteAttachment (fileName) {
      try {
        this.loadingDelete = true
        this.selectedFileName = fileName
        await campaignsService.deleteCampaignFile(
          this.token, this.companyUuid, this.appUuid, this.campaignId, fileName
        )
        this.loadingDelete = false
        this.selectedFileName = ''
        this.$emit('getCampaign')
        notifications.success(this.$t('general.fileSuccessfullyDeleted'))
      } catch (e) {
        this.loadingDelete = false
        this.selectedFileName = ''
        notifications.error(e.message)
      }
    },
    async downloadFile (fileName, filePath) {
      try {
        this.loadingDownload = true
        this.selectedFileName = fileName
        await campaignsService.downloadCampaignFile(
          this.token, this.companyUuid, this.appUuid, this.campaignId, fileName
        )
        this.loadingDownload = false
        this.selectedFileName = ''
      } catch (e) {
        this.loadingDownload = false
        this.selectedFileName = ''
        notifications.error(e)
      }
    },
    openPickFileDialog () {
      this.$refs.importerInput.click()
    },
    async pickFiles (e) {
      try {
        this.loadingAttach = true
        let filesToAttach = [...e.target.files]
        const validationResult = this.validateFiles(filesToAttach)
        if (validationResult !== true) return notifications.error(validationResult)

        const existentFilesNames = this.campaignFiles.map(file => file.name)
        filesToAttach = filesToAttach.filter(file => !existentFilesNames.includes(file.name))
        if (filesToAttach.length === 0) {
          this.loadingAttach = false
          return notifications.error(this.$t('general.fileWithSameNameAlreadyExists'))
        }
        await this.attachFilesToCampaign(filesToAttach)
        this.loadingAttach = false
        notifications.success(this.$t('general.filesSuccessfullyAttached'))
        this.$emit('getCampaign')
      } catch (err) {
        this.loadingAttach = false
        notifications.error(err.message)
      }
    },
    validateFiles (filesToAttach) {
      let isImportationValid = true
      let totalSizeSum = this.campaignFiles.reduce((a, b) => a + b, 0)
      for (let i = 0; i < filesToAttach.length; i++) {
        const size = filesToAttach[i].size
        if (size > 5 * 10 ** 6) {
          isImportationValid = this.$t('general.sizeOfFileCantExceed', { size: 5, units: 'mb' })
          break
        }
        totalSizeSum += size
        if (totalSizeSum > 24 * 10 ** 6) {
          isImportationValid = this.$t('general.filesTotalSizeMustBeSmallerThan', { size: 24, units: 'mb' })
          break
        }
      }
      return isImportationValid
    }
  },
  props: {
    campaignFiles: {
      type: Array,
      required: true
    },
    campaignId: {
      type: [String, Number],
      required: true
    },
    campaignStatus: {
      type: String,
      required: true
    }
  }
}
</script>
